import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ACustomStepWizard } from '../../../shared/components/wizard/step-wizard/abstract-custom-step-wizard';
import { Observable, of } from 'rxjs';
import { SyncDataService } from './../../services/sync-data.service';
import { IFacadeTableDescriptor } from 'app/core/typings/IFacadeTableDescriptor';
import { IFacadeExportObject } from 'app/core/typings/IFacadeExportObject';

@Component({
  selector: 'app-import-step10',
  templateUrl: './import-step10.component.html',
  styleUrls: ['./import-step10.component.scss', './../../sync-data.component.scss']
})
export class ImportStep10Component implements OnChanges {

  public selectedTables: IFacadeTableDescriptor[];
  public unselectedTables: IFacadeTableDescriptor[];
  public itemsSelectedLeft = '0';
  public itemsSelectedRight = '0';
  public errorMessage: string;
  public isLoading = false;
  private selectedItemsUI: IFacadeTableDescriptor[];
  @Input() data;
  @Input() onNext = false;
  @Output() isValidEmit = new EventEmitter<boolean>();
  constructor(private _syncDataService: SyncDataService) {
  }

  ngOnChanges(): void {
    if (this.data && !this.onNext) {
      this.load();
    }

    if (this.onNext)
      this.isValid();
  }

  public load() {
    if (this.data.syncData.EntityTables) {
      this.data.syncData.EntityTables.forEach((item) => item.SelectedUI = false);
      this.refreshList(false, '', '');
    } else {
      this.getAvailableTables();
    }
  }

  public isValid() {
    if (this.onNext) {
      this.isValidEmit.emit(true);
    }
  }


  public selectItem(item: IFacadeTableDescriptor): void {
    item.SelectedUI = !item.SelectedUI;
    this.refreshCount();
  }

  public moveAll(toExport: boolean, searchValueUnselected: string, searchValueSelected: string) {
    if (toExport === true) {
      this.unselectedTables.forEach((item) => item.SelectedUI = true);
    }
    else {
      this.selectedTables.forEach((item) => item.SelectedUI = true);
    }

    this.refreshList(toExport, searchValueUnselected, searchValueSelected);
  }

  public refreshList(toExport: boolean, searchValueUnselected: string, searchValueSelected: string): void {
    if (this.data.syncData.EntityTables) {
      this.selectedItemsUI = this.data.syncData.EntityTables.filter(
        item => item.Selected === !toExport && item.SelectedUI === true);
      this.selectedItemsUI.forEach((item) => item.Selected = toExport);
      this.selectedItemsUI.forEach((item) => item.SelectedUI = false);
      this.onSearchChange(searchValueUnselected, searchValueSelected);
      this.refreshCount();
    }
  }

  public onSearchChange(searchValueUnselected: string, searchValueSelected: string) {
    if (searchValueUnselected.length > 0) {
      this.unselectedTables = this.data.syncData.EntityTables.filter(
        table => (table.DisplayName.toUpperCase().indexOf(searchValueUnselected.toUpperCase()) > -1) &&
          (table.Selected === false));
    }
    else {
      this.unselectedTables = this.data.syncData.EntityTables.filter(table => table.Selected === false);
    }

    if (searchValueSelected.length > 0) {
      this.selectedTables = this.data.syncData.EntityTables.filter(
        table => (table.DisplayName.toUpperCase().indexOf(searchValueSelected.toUpperCase()) > -1) &&
          (table.Selected === true));
    }
    else {
      this.selectedTables = this.data.syncData.EntityTables.filter(table => table.Selected === true);
    }

    this.unselectedTables = this._syncDataService.orderEntityList(this.unselectedTables);
    this.selectedTables = this._syncDataService.orderEntityList(this.selectedTables);
  }

  public changeSelected(selected, event) {
    if (event.target.tagName !== 'LABEL') {
      selected.SelectedUI = !selected.SelectedUI;
    }
  }

  private getAvailableTables(): void {
    this.isLoading = true;
    this._syncDataService.getImportTables(this.data.syncData.FileToImport).then((serverData: IFacadeExportObject) => {

      this.data.syncData.EnabledMail = serverData.EnabledMail;
      this.data.syncData.Reports = serverData.Reports;
      this.data.syncData.EntityTables = serverData.EntityTables;
      this.data.syncData.UserTables = serverData.UserTables;
      this.data.syncData.AreNewUsers = serverData.AreNewUsers;
      this.data.syncData.ModifiedDescriptor = serverData.ModifiedDescriptor;
      this.data.syncData.OriginalDescriptor = serverData.OriginalDescriptor;
      this.data.syncData.UsersAvailable = serverData.UsersAvailable;
      this.data.syncData.UsersSelected = serverData.UsersSelected;
      this.data.syncData.FilePath = serverData.FilePath;

      this.isLoading = false;
      this.refreshList(false, '', '');
    })
      .catch(error => {
        this.isLoading = false;
        this.errorMessage = error;
      });
  }

  private refreshCount() {
    this.itemsSelectedLeft = this.unselectedTables.length.toString();
    this.itemsSelectedRight = this.selectedTables.length.toString();
  }

}
